interface MiniLineChartProps {
  data: { label: string; value: number }[];
  height?: number;
  color?: string;
  currency?: string;
}

export default function MiniLineChart({ data, height = 180, color = '#0d9488', currency = '' }: MiniLineChartProps) {
  if (data.length === 0) return null;

  const maxVal = Math.max(...data.map(d => d.value), 1);
  const minVal = Math.min(...data.map(d => d.value), 0);
  const range = maxVal - minVal || 1;
  const padding = { top: 30, bottom: 40, left: 50, right: 20 };
  const chartWidth = Math.max(data.length * 50, 300);
  const chartHeight = height;

  function toX(i: number) {
    return padding.left + (i / Math.max(data.length - 1, 1)) * (chartWidth - padding.left - padding.right);
  }

  function toY(val: number) {
    return padding.top + (1 - (val - minVal) / range) * (chartHeight - padding.top - padding.bottom);
  }

  const points = data.map((d, i) => `${toX(i)},${toY(d.value)}`).join(' ');
  const areaPoints = `${toX(0)},${chartHeight - padding.bottom} ${points} ${toX(data.length - 1)},${chartHeight - padding.bottom}`;

  return (
    <div className="w-full overflow-x-auto">
      <svg width={chartWidth} height={chartHeight} viewBox={`0 0 ${chartWidth} ${chartHeight}`} className="mx-auto">
        {[0, 0.5, 1].map((frac) => {
          const val = minVal + frac * range;
          const y = toY(val);
          return (
            <g key={frac}>
              <line x1={padding.left} y1={y} x2={chartWidth - padding.right} y2={y} stroke="rgba(255,255,255,0.1)" strokeWidth="1" strokeDasharray="4" />
              <text x={padding.left - 6} y={y + 4} textAnchor="end" fill="rgba(255,255,255,0.7)" fontSize="10">
                {val >= 1000 ? `${(val / 1000).toFixed(1)}k` : val.toFixed(0)}
              </text>
            </g>
          );
        })}

        <polygon points={areaPoints} fill={color} opacity="0.08" />
        <polyline points={points} fill="none" stroke={color} strokeWidth="2.5" strokeLinejoin="round" strokeLinecap="round" />

        {data.map((d, i) => (
          <g key={i}>
            <circle cx={toX(i)} cy={toY(d.value)} r="4" fill="white" stroke={color} strokeWidth="2" />
            <text x={toX(i)} y={toY(d.value) - 10} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10" fontWeight="600">
              {currency}{d.value >= 1000 ? `${(d.value / 1000).toFixed(1)}k` : d.value.toFixed(0)}
            </text>
            <text x={toX(i)} y={chartHeight - padding.bottom + 18} textAnchor="middle" fill="rgba(255,255,255,0.7)" fontSize="10">
              {d.label}
            </text>
          </g>
        ))}
      </svg>
    </div>
  );
}
